import { jsx as _jsx } from "react/jsx-runtime";
import _defineProperty from "/usr/src/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

var _query, _query2, _query3;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { UtilsMenuDropdown } from "@vc-workspace/utils-menu-dropdown";
import { SortByKey } from "@vc-workspace/utils-constants";
/* eslint-disable-next-line */

var SortOptions = [{
  label: 'Relevancy',
  value: 'score',
  active: true,
  query: (_query = {}, _defineProperty(_query, SortByKey, 'score'), _defineProperty(_query, 'sortOrder', 'DESC'), _query),
  itemCount: 0
}, {
  label: 'Low Pricing',
  value: 'sellingPrice',
  query: (_query2 = {}, _defineProperty(_query2, SortByKey, 'sellingPrice'), _defineProperty(_query2, 'sortOrder', 'ASC'), _query2),
  itemCount: 0
}, {
  label: 'High Pricing',
  value: 'sellingPrice',
  query: (_query3 = {}, _defineProperty(_query3, SortByKey, 'sellingPrice'), _defineProperty(_query3, 'sortOrder', 'DESC'), _query3),
  itemCount: 0
}];
export function SortFilterDropdownMenu(props) {
  var _sortOptions$filter$;

  var selectedFilterLabel = '';
  var sortOptions = SortOptions; // Check for string in substring and array both

  if (props.context.query[SortByKey]) {
    sortOptions = sortOptions.map(function (item) {
      if (item.value === props.context.query[SortByKey] && item.query.sortOrder === props.context.query['sortOrder']) {
        item.active = true;
      } else {
        item.active = false;
      }

      return item;
    });
  }

  selectedFilterLabel = (_sortOptions$filter$ = sortOptions.filter(function (item) {
    return item.active;
  })[0]) === null || _sortOptions$filter$ === void 0 ? void 0 : _sortOptions$filter$.label;
  return /*#__PURE__*/_jsx("div", {
    className: "inline-block ml-8",
    children: /*#__PURE__*/_jsx(UtilsMenuDropdown, {
      placeholderText: "".concat(selectedFilterLabel ? selectedFilterLabel : ''),
      menuOptions: sortOptions,
      queryKey: SortByKey,
      query: _objectSpread(_objectSpread({}, props.context.query), {}, {
        'page': '1'
      }),
      basePath: props.context.pathname,
      whiteTheme: props.whiteTheme
    })
  });
}
export default SortFilterDropdownMenu;